import financial_accounts from './financial_accounts'
import navigator from "./navigator";
export default {
    financial_accounts,
    navigator
};